// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-10-29T07:54:36Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Kontroler pro lokalizaci. Generated from cz.marbes.eosp.controller.LokalizaceController.
 */
export default class LokalizaceApi {
    /**
     * 
     *
     * @param language 
     */
    static setJazyk(language) {
        const uri = serverContextPath + `/api/lokalizace/jazyk`;
        const headers = undefined;
        const params = { language };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @return java.util.Map<java.lang.String,java.util.Map<java.lang.String,java.lang.String>>
     */
    static getZpravy() {
        const uri = serverContextPath + `/api/lokalizace/zpravy`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return java.util.List<java.lang.String>
     */
    static getPovoleneJazyky() {
        const uri = serverContextPath + `/api/lokalizace/jazyk`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
